import { auth } from "../../../backend/firebaseconfig";

export async function requestEntries(
  path,
  userEmail = "",
  userRole = "",
  signal,
) {
  const base = (
    process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001"
  ).replace(/\/$/, "");
  const url = `${base}/api/my-entries${path}`;
  // Force a refresh so the API always receives the current Firebase user's
  // token after a sign-in/account switch.
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) {
    // console.error("[Business Summary API] Missing Firebase authentication token", {
    //   url,
    // });
    throw new Error("Please sign in again.");
  }
  // console.info("[Business Summary API] Request", {
  //   method: "GET",
  //   url,
  //   userEmail: userEmail || auth.currentUser?.email || "",
  //   userRole: userRole || "",
  // });
  // console.info("[Business Summary API] Request", {
  //   method: "GET",
  //   url,
  //   userEmail: userEmail || auth.currentUser?.email || "",
  //   userRole: userRole || "",
  //   authenticated: Boolean(token),
  // });
  let response;
  try {
    response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-User-Email": userEmail || auth.currentUser?.email || "",
        "X-User-Role": userRole || "",
      },
      signal,
    });
  } catch (error) {
    if (error?.name !== "AbortError") {
      // console.error("[Business Summary API] Network failure", {
      //   method: "GET",
      //   url,
      //   error,
      // });
    }
    throw error;
  }
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    // console.error("[Business Summary API] Failed", {
    //   method: "GET",
    //   url,
    //   status: response.status,
    //   statusText: response.statusText,
    //   body,
    // });
    throw new Error(body.error || "Unable to load entries.");
  }
  // console.info("[Business Summary API] Success", {
  //   method: "GET",
  //   url,
  //   status: response.status,
  //   body,
  // });
  return body;
}
